import axios from "axios";
import headers from "./Header";
let url = "/sdi";
let url_api = '/api'
class SdiService {
  getNews(page, size, project,title) {
    return axios.get(url_api + "/news?page=" + page + "&size="+size+"&project=" + project+"&title=" + title, {
        headers: headers(),
      });
  }

  getNewsDetail(slug) {
    return axios.get(url_api + "/news/detail?slug="+slug, {
        headers: headers(),
      });
  }
  getData(query, page, status) {
    if (status) {
      return axios.get(url + "/data/" + query + "?page=" + page + "&size=10&status=" + status, {
        headers: headers(),
      });
    } else {
      return axios.get(url + "/data/" + query + "?page=" + page + "&size=10&status=", {
        headers: headers(),
      });
    }

  }

  getDataByDivisi(query, page, divisi, status) {
    if (status) {
      return axios.get(url + "/data/" + query + "?page=" + page + "&responsible_division="+divisi+"&size=10&status=" + status, {
        headers: headers(),
      });
    } else {
      return axios.get(url + "/data/" + query + "?page=" + page + "&responsible_division="+divisi+"&size=10&status=", {
        headers: headers(),
      });
    }

  }

  getDataByOrganisasi(query, responsible_organization) {
    return axios.get(url + "/data/" + query + "?page=0&responsible_organization=" + responsible_organization + "&size=10", {
      headers: headers(),
    });
  }

  getDataByDivision(query, responsible_division) {
    return axios.get(url + "/data/" + query + "?page=0&responsible_division=" + responsible_division + "&size=10", {
      headers: headers(),
    });
  }

  getMetadataVariabelByKegiatan(query, page) {
    return axios.get(
      url +
      "/metadata-statistik-kegiatan/" +
      query +
      "/metadata-statistik-variabel?page=" +
      page +
      "&size=10",
      {
        headers: headers(),
      }
    );
  }

  getMetadataIndikatorByKegiatan(query, page) {
    return axios.get(
      url +
      "/metadata-statistik-kegiatan/" +
      query +
      "/metadata-statistik-indikator?page=" +
      page +
      "&size=10",
      {
        headers: headers(),
      }
    );
  }

  getDataById(query, id) {
    return axios.get(url + "/data/" + query + "/" + id, {
      headers: headers(),
    });
  }

  getItemById(query, id, page) {
    return axios.get(url + "/data/" + query + "/" + id + "/item-"+query+"?page=" + page, {
      headers: headers(),
    });
  }

  getDataByRequester(query, id, page) {
    return axios.get(
      url + "/requesters/" + query + "/" + id + "?page=" + page + "&size=5",
      {
        headers: headers(),
      }
    );
  }

  postItemUsulanStandarData(query, id, data) {
    return axios.post(url + "/" + query + "/" + id + "/item-usulan-baru-standar-data-statistik", data, {
      headers: headers(),
    });
  }

  postItemUsulanPemutakhiranStandarData(query, id, data) {
    return axios.post(url + "/" + query + "/" + id + "/item-usulan-pemutakhiran-standar-data-statistik", data, {
      headers: headers(),
    });
  }

  postData(query, data) {
    return axios.post(url + "" + query, data, {
      headers: headers(),
    });
  }

  putData(query, id, data) {
    return axios.put(url + "" + query + "/" + id, data, {
      headers: headers(),
    });
  }

  approvalData(query, id, data) {
    return axios.put(url + "/approval/" + query + "/" + id, data, {
      headers: headers(),
    });
  }

  deleteData(query, data) {
    return axios.delete(url + "/" + query + "/" + data, {
      headers: headers(),
    });
  }

  getDashboard(query) {
    return axios.get(url + "/dashboard/" + query, {
      headers: headers(),
    });
  }

  getAllVariable(){
    return axios.get(url + "/get-all-variable", {
      headers: headers(),
    });
  }
  getAllIndicator(){
    return axios.get(url + "/get-all-indicator", {
      headers: headers(),
    });
  }


}

export default new SdiService();
